import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Set } from 'src/app/models/set';
import { Unity } from 'src/app/models/unity';
import { UnityService } from 'src/app/services/unity.service';
import { DriverService } from 'src/app/services/driver.service';
import { Driver } from 'src/app/models/driver';
import { UtilitiesService } from 'src/app/services/utilities.service';
import { ToastrManager } from 'ng6-toastr-notifications';

@Component({
  selector: 'app-set',
  templateUrl: './set.component.html',
  styleUrls: ['./set.component.css']
})
export class SetComponent implements OnInit {
  set:Set;
  sets:Set[];
  unity:Unity;
  unities:Unity[] = [];
  drivers:Driver[] = [];
  driverOther:Driver;
  driver:Driver;
  loading:boolean = false;

  unitiesContrac:Unity[]=[];
  unitiesOther:Unity[]=[];

  constructor(private modalService: NgbModal, private unityServ:UnityService, private driverServ:DriverService, private utl:UtilitiesService, private toastr: ToastrManager) { }

  ngOnInit() {
    this.loading = true;
    this.driverServ.getDrivers().then(drivers => {
      for(let driver of drivers){
        if(driver.name == "Otro"){
          this.driverOther = driver;
        }else{
          this.drivers.push(driver);
        }
      }
    });

    this.unityServ.getUnities().then(unities => {
      this.unities = unities;
      for(let uni of this.unities){
        if(uni.unit_type.name == "Contratistas"){
          this.unitiesContrac.push(uni);
        }else{
          this.unitiesOther.push(uni);
        }
      }
    });
    

    this.unityServ.getSets().then(sets => {
      this.sets = sets;
      this.loading = false;
    })

  }

  select(modal) {
    this.set = new Set();
    this.modalService.open(modal, { size: 'lg' });
  }

  storeSet(event) {
    event.preventDefault();

    this.loading = true;
    
    let setTmp:Set = {
      helper_1: null,
      helper_1_id: this.set.helper_1 ? this.set.helper_1_id : null,
      helper_2: null,
      helper_2_id: this.set.helper_2 ? this.set.helper_2_id : null,
      id: 0,
      operator: null,
      operator_id: this.set.operator ? this.set.operator_id : null,
      trailer_1: null,
      trailer_1_id: this.set.trailer_1 ? this.set.trailer_1_id : null,
      trailer_2: null,
      trailer_2_id: this.set.trailer_2 ? this.set.trailer_2_id : null,
      trailer_3: null,
      trailer_3_id: this.set.trailer_3 ? this.set.trailer_3_id : null,
      truck: null,
      truck_id: this.set.truck ? this.set.truck_id : null,
      contracted: this.set.contracted,
    };

    if (this.set.truck && this.set.operator) {
      if(this.set.contracted){
        if(this.set.truck.unit_type_id == 20){
          if(!this.existConfiguration(setTmp)){
            this.unityServ.postSet(setTmp).then(set => {
              this.sets.push(set);
              this.loading = false;
              this.toastr.successToastr('Creado Correctamente');
            }).catch(e => {
              this.toastr.errorToastr(this.utl.formatMessages(e), 'Oops!', { enableHTML: true })
              this.loading = false;
            });
          }else{
            this.toastr.errorToastr('La configuración que desea guardar ya existe');
          }
        }else{
          this.toastr.infoToastr('Verifica que la sección de Tractocamión este como contratista');
        }
      }else{
        if(this.canAddTruck(this.set.truck.unit_type_id) && this.set.truck.unit_type_id != 20){
          if(!this.existConfiguration(setTmp)){
            this.unityServ.postSet(setTmp).then(set => {
              this.sets.push(set);
              this.loading = false;
              this.toastr.successToastr('Creado Correctamente');
            }).catch(e => {
              this.toastr.errorToastr(this.utl.formatMessages(e), 'Oops!', { enableHTML: true })
              this.loading = false;
            });
          }else{
            this.toastr.errorToastr('La configuración que desea guardar ya existe');
          }
        }else{
          this.toastr.infoToastr('Verifica que la sección de Tractocamión sea diferente a contratista');
        }
      }
    } else {
      this.toastr.infoToastr("Debe elegir por lo menos un tractocamión y un operador.");
    }
    this.loading = false;
  }

  existConfiguration(setTmp:Set):boolean{
    let flag:boolean = false;
    for(let set of this.sets){
      if(set.truck_id == setTmp.truck_id && setTmp.truck_id != null &&
        set.trailer_1_id == setTmp.trailer_1_id &&
        set.trailer_2_id == setTmp.trailer_2_id &&
        set.trailer_3_id == setTmp.trailer_3_id &&
        set.operator_id == setTmp.operator_id && setTmp.operator_id != null &&
        set.helper_1_id == setTmp.helper_1_id &&
        set.helper_2_id == setTmp.helper_2_id
      )flag=true;
    }
    return flag;
  }

  addTruck() {
    if(this.canAddTruck(this.unity.unit_type_id)) {
      this.set.truck_id = this.unity.id;
      this.set.truck = this.unity;
    }else{
      this.set.truck_id = null;
      this.set.truck = null;
      this.toastr.infoToastr("El Tractocamión solo puede ser de tipo: Tractocamión, Torton Plataforma, Torton Caja Seca, Torton Volteo, Camioneta ó Contratista");
    }
  }

  addOperator() {
    if(this.driver) {
      this.set.operator = this.driver;
      this.set.operator_id = this.driver.id;
    }
  }

  addHelper(number:number) {
    if(this.driver) {
      if(number == 1 ) { 
        this.set.helper_1 = this.driver;
        this.set.helper_1_id = this.driver.id;
      } else if(number == 2 ) { 
        this.set.helper_2 = this.driver;
        this.set.helper_2_id = this.driver.id;
      }
    }
  }

  addArrastre(number:number) {
    if(this.unity) {
      switch(number){
        case 1:
          if(this.canAddArrastre(this.unity.unit_type_id)){
            this.set.trailer_1_id = this.unity.id;
            this.set.trailer_1 = this.unity;
          }else{
            this.set.trailer_1_id = null;
            this.set.trailer_1 = null;
            this.toastr.infoToastr("El arrastre 1 solo puede ser de tipo: "+
            "Plana, Tanque de Acero al carbón con recubrimiento, Tanque de Acero al carbón sin recubrimiento, "+
            "Gondola, Caja Seca ó Tolva.");
          }
          break;
        case 2:
          if(this.unity.unit_type.name == "Dolly"){
            this.set.trailer_2_id = this.unity.id;
            this.set.trailer_2 = this.unity;
          }else{
            this.set.trailer_2_id = null;
            this.set.trailer_2 = null;
            this.toastr.infoToastr("El arrastre 2 solo puede ser de tipo Dolly");
          }
          break;
        case 3:
          if(this.canAddArrastre(this.unity.unit_type_id)){
            this.set.trailer_3_id = this.unity.id;
            this.set.trailer_3 = this.unity;
          }else{
            this.set.trailer_3_id = null;
            this.set.trailer_3 = null;
            this.toastr.infoToastr("El arrastre 1 solo puede ser de tipo: "+
            "Plana, Tanque de Acero al carbón con recubrimiento, Tanque de Acero al carbón sin recubrimiento "+
            "Gondola, Caja Seca ó Tolva.");
          }
          break;
      }
    }
  }

  canAddTruck(unit:number):boolean{
    return (unit == 1 || unit == 8 || unit == 9 || unit == 10 || unit == 12 || unit == 20);
  }

  canAddArrastre(unit:number):boolean{
    return (unit == 2 || unit == 3|| unit ==4 || unit ==5 || unit == 6 ||unit == 7);
  }

}
